export default function () {
  return [
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'userIds',
      label: 'depositor',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      key: 'types',
      label: 'type',
      type: 'select',
      props: {
        options: [
          { label: 'Deposit', code: 'DEPOSIT' },
          { label: 'Withdrawal', code: 'WITHDRAWAL' },
        ],
        label: 'label',
        reduce: opt => opt.code,
        clearable: true,
        multiple: true,
      },
      collapsed: true,
      collapsedMinWidth: '450px',
    },
    {
      // Takes TXF (taxes) money OUT of the deposit/withdrawal/net KPIs.
      // Inline (collapsed: true) so it's usable without expanding the filters.
      key: 'excludeTxf',
      label: 'excludeTxf',
      type: 'checkbox',
      collapsed: true,
      props: { style: 'margin-top: 6px; white-space: nowrap' },
    },
  ];
}
